export default "__VITE_ASSET__CWISaxOx__"